// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Wednesday`
};

const el_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Τετάρτη`
};

const ru_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `Среда`
};

const he_wednesday = /** @type {(inputs: {}) => string} */ () => {
	return `יום רביעי`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wednesday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wednesday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("wednesday", locale)
	if (locale === "en") return en_wednesday(inputs)
	if (locale === "el") return el_wednesday(inputs)
	if (locale === "ru") return ru_wednesday(inputs)
	if (locale === "he") return he_wednesday(inputs)
	return "wednesday"
};